module.exports = __webpack_public_path__ + "tn.svg?2b346131570731fcd8710ed7be17bd6f";